import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            meta: {
                title: "Home",
                requiresAuth: true
            },
            path: "/",
            component: () => import("@/layouts/MasterLayout.vue"),
            children: [
                {
                    name: "home",
                    path: "home",
                    component: () => import("@/views/QuotesView.vue"),
                },
                {
                    name: "newquote",
                    path: "newquote",
                    component: () => import("@/views/NewQuoteView.vue"),
                },
                {
                    name: "reports",
                    path: "reports",
                    component: () => import("@/views/ReportsView.vue"),
                }, 
                {
                    name: "works",
                    path: "works",
                    component: () => import("@/views/WorksView.vue"),
                },
                {
                    name: "customers",
                    path: "customers",
                    component: () => import("@/views/CustomersView.vue"),
                },
                {
                    name: "vendor",
                    path: "vendor",
                    component: () => import("@/views/VendorView.vue"),
                },
                {
                    name: "store",
                    path: "store",
                    component: () => import("@/views/StoreView.vue"),
                },
                {
                    name: "products",
                    path: "products",
                    component: () => import("@/views/ProductsView.vue"),
                },
                {
                    name: "approve",
                    path: "approve/:id",
                    props: true,
                    component: () => import("@/views/ApproveView.vue"),
                    beforeEnter: (to, from, next) => {
                        const hasIdParam = to.params.id;
                        if (!hasIdParam) {
                            // Si no se proporciona un :id, redirige a otra vista, por ejemplo, "acceso-denegado"
                            next({ name: 'home' });
                        } else {
                            next(); // Continuar con la navegación si se proporciona un :id
                        }
                    },
                },
                {
                    name: "update",
                    path: "update/:id",
                    props: true,
                    component: () => import("@/views/UpdateView.vue"),
                    beforeEnter: (to, from, next) => {
                        const hasIdParam = to.params.id;
                        if (!hasIdParam) {
                            // Si no se proporciona un :id, redirige a otra vista, por ejemplo, "acceso-denegado"
                            next({ name: 'home' });
                        } else {
                            next(); // Continuar con la navegación si se proporciona un :id
                        }
                    },
                }
            ]
        },
        {
            meta: {
                title: "Login"
            },
            path: "/login",
            name: "login",
            component: () => import("@/views/LoginView.vue")
        }
    ]
})
// Navigation Guard
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth && !store.state.isAuthenticated) {
        // Si la ruta requiere autenticación y el usuario no está autenticado, redirigir a la página de inicio de sesión
        next({ name: 'login' });
    } else if (to.name === 'login' && store.state.isAuthenticated) {
        next({ name: 'home' });
    } else if (to.path === '/' && store.state.isAuthenticated) {
        next({ name: 'home' });
    } else {
        next();
    }

});
export default router;


